import styled from 'styled-components';

import theme from 'v3/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
`;

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Summary = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
`;

export const SummaryItem = styled.div`
  border: 1px solid ${theme.colors.secondary};
  border-radius: 8px;
  padding: 12px 14px;
  background: ${theme.colors.light_gray};
`;

export const Legend = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const LegendItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 999px;
  background: ${theme.colors.light_gray};
  border: 1px solid ${theme.colors.secondary};
`;

export const LegendDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ $background }) => $background};
  flex-shrink: 0;
`;

export const MapContainer = styled.div`
  position: relative;
  overflow: visible;
  border-radius: 12px;
  border: 1px solid ${theme.colors.secondary};
  background: ${theme.colors.white};
  height: 560px;

  .leaflet-container {
    height: 100%;
    width: 100%;
  }

  .leaflet-top,
  .leaflet-bottom,
  .leaflet-control {
    z-index: 500;
  }

  .leaflet-routing-container {
    display: none !important;
  }

  @media (max-width: 768px) {
    height: 420px;
  }
`;

export const ReadOnlyOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1000;
  background: transparent;
  cursor: default;
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 24px;
  text-align: center;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
`;

export const ErrorBox = styled.div`
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.error};
  background: ${theme.colors.error_light};
`;
